import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProjectsService, UsersService } from '@cosmos/angular/api';
import { ErrorService, StateService } from '@cosmos/angular/utils';
import { Project, User } from '@cosmos/shared';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ChipModule } from 'primeng/chip';


@Component({
    selector: 'cosmos-project-share-settings',
    imports: [
        TranslatePipe, FormsModule,
        DividerModule, InputTextModule, ChipModule, SelectModule, FloatLabelModule, ButtonModule
    ],
    templateUrl: 'project-share-settings.component.html'
})

export class ProjectShareSettingsComponent implements OnInit {

    @Input()
    projectId: string | undefined = undefined;

    project: Project = null;
    user: User;

    shareWithEmail: string = "";
    accessLevel: string;
    privileges;
    // @Output()
    // updatedProject = new EventEmitter<Project>();

    constructor(
        private projectsService: ProjectsService,
        private userService: UsersService,
        private stateService: StateService,
        private translateService: TranslateService,
        private errorService: ErrorService,
    ) { }

    ngOnInit() {
        this.user = this.stateService.getCurrentUser();
        this.getData();
        this.privileges = [
            { label: this.translateService.instant('privileges.readonly'), value: 'readonly'},
            { label: this.translateService.instant('privileges.write'), value: 'write'}
        ]
    }
    // updateProject(updateObject) {
    //     this.projectsService.update([this.project._id, updateObject]).subscribe({
    //         next: (response) => this.updatedProject.emit(response.body),
    //         error: (e) => this.errorService.handleError(e)
    //     });
    // }
    getData() {
        this.projectsService.findById(this.projectId, '?populate_shared_w=email,name&populate_shared_r=email,name').subscribe({
            next: (response) => this.project = response.body,
            error: (e) => this.errorService.handleError(e)
        });
    }

    addUser() {
        this.userService.find(`/?email=${this.shareWithEmail}&select=email,name`).subscribe({
            next: (response) => {
                if (response.body[0] === undefined) {
                    // ADD TOAST this.translateService.instant("projects.shared.not_registered"));
                    return;
                }
                const foundUser = response.body[0];
                if (foundUser._id === this.user._id) {
                    // ADD TOAST this.translateService.instant("projects.shared.self"))
                }

                if (
                    this.project.shared_w.find( (user) => {return user['_id'] === foundUser._id}) ||
                    this.project.shared_r.find( (user) => {return user['_id'] === foundUser._id})
                ) {
                    // ADD TOAST this.translateService.instant("projects.shared.error")+ foundUser.name);
                    return;
                }
                const body = { "$addToSet": { } };
                if(this.accessLevel == 'write') body['$addToSet'] = { "shared_w": foundUser._id };
                if(this.accessLevel == 'readonly') body['$addToSet'] = { "shared_r": foundUser._id };
                
                this.projectsService.update([this.project._id, body]).subscribe({
                    next: (response) => {
                        this.accessLevel = null;
                        this.shareWithEmail = '';
                        this.getData();
                        // ADD TOAST this.translateService.instant("projects.shared.success") + foundUser.name);
                    },
                    error: (e) => this.errorService.handleError(e),
                });
            }
        })
    }
    
    removeAccess(userId, accessLevel) {
        const body = { "$pull": { } };
        body['$pull'][accessLevel] = userId;
        // if(accessLevel == 'readonly') body['$pull'] = { "shared_r": userId };

        this.projectsService.update([this.projectId, body]).subscribe({
            next: (response) => {this.getData()},
            error: (e) => {this.errorService.handleError(e); this.getData()}
        });
    }
}